import { Icon } from "@iconify/react";
import Avatar from "./Avatar";

const OpenCallTieBreaker = ({
  tieGroups,
  automaticWinners,
  selections,
  onSelectionChange,
  getUserById,
  getUserNameById,
  getShotComment,
  onCancel,
  onConfirm,
  validationError,
}) => {
  const isComplete = tieGroups.every((group, groupIndex) => {
    const selected = selections[groupIndex] || [];
    return selected.length === group.spotsToFill;
  });

  const toggleCandidate = (groupIndex, candidateId) => {
    const group = tieGroups[groupIndex];
    const current = selections[groupIndex] || [];
    const candidateKey = String(candidateId);

    if (current.includes(candidateKey)) {
      onSelectionChange(
        groupIndex,
        current.filter((id) => id !== candidateKey),
      );
      return;
    }

    if (current.length >= group.spotsToFill) {
      return;
    }

    onSelectionChange(groupIndex, [...current, candidateKey]);
  };

  return (
    <>
      <div className="backdrop" onClick={onCancel} />
      <div className="opencall-tie-breaker-modal">
        <div className="opencall-tie-breaker-header">
          <Icon icon="mdi:scale-balance" width={28} height={28} />
          <h2>Resolve voting ties</h2>
        </div>

        <p className="opencall-tie-breaker-intro">
          Multiple volunteers received the same number of votes. Select who should
          win the remaining spot{tieGroups.some((g) => g.spotsToFill > 1) ? "s" : ""}.
        </p>

        {automaticWinners.length > 0 && (
          <div className="opencall-tie-breaker-automatic">
            <strong>Already selected ({automaticWinners.length}):</strong>
            <div className="opencall-tie-breaker-automatic-list">
              {automaticWinners.map((userId) => (
                <span key={userId} className="opencall-tie-breaker-automatic-item">
                  <Avatar user={getUserById(userId)} size={32} />
                  {getUserNameById(userId)}
                </span>
              ))}
            </div>
          </div>
        )}

        {tieGroups.map((group, groupIndex) => {
          const selected = selections[groupIndex] || [];
          const spotsLabel =
            group.spotsToFill === 1 ? "1 spot" : `${group.spotsToFill} spots`;

          return (
            <div key={groupIndex} className="opencall-tie-breaker-group">
              <h3>
                Tie with {group.voteCount} vote{group.voteCount === 1 ? "" : "s"} —
                pick {spotsLabel}
              </h3>
              <p className="opencall-tie-breaker-progress">
                Selected {selected.length} of {group.spotsToFill}
              </p>
              <ul className="opencall-tie-breaker-candidates">
                {group.candidates.map((candidateId) => {
                  const isSelected = selected.includes(String(candidateId));
                  const isDisabled =
                    !isSelected && selected.length >= group.spotsToFill;
                  const shotComment = getShotComment?.(candidateId);

                  return (
                    <li key={candidateId}>
                      <label
                        className={`opencall-tie-breaker-candidate${
                          isSelected ? " is-selected" : ""
                        }${isDisabled ? " is-disabled" : ""}`}
                      >
                        <input
                          type="checkbox"
                          checked={isSelected}
                          disabled={isDisabled}
                          onChange={() => toggleCandidate(groupIndex, candidateId)}
                        />
                        <Avatar user={getUserById(candidateId)} size={32} />
                        <span className="opencall-tie-breaker-candidate-name">
                          {getUserNameById(candidateId)}
                          {shotComment && (
                            <span className="opencall-tie-breaker-candidate-comment">
                              — {shotComment}
                            </span>
                          )}
                        </span>
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}

        {validationError && (
          <p className="opencall-tie-breaker-error">{validationError}</p>
        )}

        <div className="opencall-tie-breaker-actions">
          <button type="button" className="button back-button" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="button confirm-button"
            disabled={!isComplete}
            onClick={onConfirm}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default OpenCallTieBreaker;
